import { Box, Typography } from '@mui/material';
import { differenceInDays } from 'date-fns';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { useIsDesktop } from 'Hooks';

const MAX_DAYS_VIEW = 14;
interface IISNew {
  docDate: string;
}
export const IsNew = ({ docDate }: IISNew) => {
  const isDesktop = useIsDesktop();

  if (differenceInDays(new Date(), new Date(docDate)) > MAX_DAYS_VIEW)
    return null;

  return (
    <Box
      sx={{
        position: 'absolute',
        top: isDesktop ? 0 : '5px',
        right: isDesktop ? '-25px' : '-10px',
        p: '0 8px',
        color: '#FFF',
        bgcolor: isDesktop ? '#B756FF' : '#3A6EEC',
        borderRadius: '0 12px 0 6px',
      }}
    >
      <Typography variant='body6'>
        {Dictionary[DICTIONARY.Documents].new}
      </Typography>
      <Box
        sx={{
          position: 'absolute',
          right: 0,
          width: 0,
          height: 0,
          borderRight: '10px solid transparent',
          borderTop: isDesktop ? '8px solid #6D16AD' : '8px solid #1752AF',
        }}
      ></Box>
    </Box>
  );
};
